import { useState } from 'react';
import api from '../services/api';

// Create a QC ticket for a job — fill out the issue, hit submit.
export default function QCTicketModal({ job, onClose, onCreated }) {
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function submit(e) {
    e.preventDefault();
    if (!note.trim()) { setError('Describe the QC issue.'); return; }
    setSubmitting(true);
    setError('');
    try {
      await api.post('/qc', { project_id: job.project_id, client: job.client_name, note });
      onCreated();
    } catch {
      setError('Failed to create the QC ticket. Please try again.');
      setSubmitting(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
      <form onSubmit={submit} className="w-full max-w-lg rounded-xl border border-navy-500 p-6" style={{ backgroundColor: '#142236' }}>
        <div className="flex items-start justify-between mb-4">
          <div>
            <h2 className="text-white font-bold text-lg">🔍 New QC Ticket</h2>
            <p className="text-gray-400 text-xs mt-0.5 font-mono">{job.project_id}{job.client_name ? ` — ${job.client_name}` : ''}</p>
          </div>
          <button type="button" onClick={onClose} className="text-gray-500 hover:text-white transition text-xl leading-none">&times;</button>
        </div>

        <label className="block text-xs text-gray-400 uppercase tracking-wide mb-1">QC Note (the issue)</label>
        <textarea
          autoFocus
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={4}
          placeholder="Describe the issue found during QC…"
          className="w-full rounded px-3 py-2 text-sm text-white placeholder-gray-500 border focus:outline-none resize-y"
          style={{ backgroundColor: '#0f1a29', borderColor: '#1e3a5f' }}
        />
        <p className="text-gray-500 text-xs mt-2">Category is auto-assigned from the note; the offender is pulled from the project's Site Tracker PM (editable on the QC page).</p>

        {error && <p className="text-red-400 text-xs mt-3">{error}</p>}

        <div className="flex gap-3 mt-5">
          <button type="submit" disabled={submitting} className="flex-1 bg-gold-500 text-navy-900 py-2 rounded font-bold uppercase tracking-wide text-sm hover:bg-gold-400 disabled:opacity-50 transition">
            {submitting ? 'Submitting…' : 'Submit QC Ticket'}
          </button>
          <button type="button" onClick={onClose} disabled={submitting} className="px-4 py-2 rounded border border-navy-500 text-gray-400 text-sm hover:text-white hover:border-gray-400 transition">Cancel</button>
        </div>
      </form>
    </div>
  );
}
